import { FunctionComponent } from "preact";

import * as dateish from "@/dateish";

import * as db from "@/db";
import SpeciesTable from "@/ui/species_table";
import { LinkDoY } from "@/ui/date_link";

const DayPage: FunctionComponent<{ // TODO: Rename DoY page?
  date: dateish.DoY
  store: db.Store
}> = ({ date, store }) => {
  // TODO: Forward adds day of months that don't exist for short months
  return <div class="content day-view">
    <div class='day-header'>
      <LinkDoY class='prev' doy={ dateish.doyPrev(date) } />
      <h2>{ dateish.doyDisplay(date) }</h2>
      <LinkDoY class='next' doy={ dateish.doyNext(date) } />
    </div>
    {/* <ObservationTable query={ store.doySpecies.bind(store, date) } /> */}
    <SpeciesTable query={ store.doySpeciesTable.bind(store, date) } taxonomy={ store.taxonomy } />
  </div>;
}

export default DayPage;
